import { AbstractDialogContent } from '../../../../abstracts/dialog/dialog-content';
import { Component, Injector, OnInit } from '@angular/core';
import { IEntity } from '../../../../interfaces/entity';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Manufacturer } from '../../../../models/manufacturer';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ManufacturersService } from '../../../../services/entity/manufacturer.services';
import { ModelsService } from '../../../../services/entity/models.services';
import { FormService } from '../../../../services/form/form.service';
import { ToastService } from '../../../../services/toast/toast.service';
import { FilesService } from '@services/files/files.service';
import Swal from 'sweetalert2';
import { Model } from '../../../../models/model';
import { Profile } from '../../../../models/profile';
import { ManufacturerDto } from '../../../../dto/manufacturerDto';
import { ModelDto } from '../../../../dto/modelDto';
import { PatchUserProfilePicture } from '../../../../dto/httpPatch/userProfile';
import { UploadResponse } from '../../../../dto/uploadResponse';

@Component({
  selector: 'app-create-chargingstationprofile-dialog-content',
  templateUrl: './create-chargingstationprofile-dialog-content.component.html',
  styleUrls: ['./create-chargingstationprofile-dialog-content.component.scss'],
})

export class CreateChargingStationProfileDialogContentComponent extends AbstractDialogContent implements OnInit {

  public className = 'CreateChargingStationProfileDialogContentComponent';

  public customerId: number;

  public picture: File;
  public pictureUri: string;

  public manufacturer: ManufacturerDto[];

  selected: any;
  filtered: any;
  formCreated = false;
  

  constructor(
    public activeModal: NgbActiveModal,
    public manufacturerService: ManufacturersService,
    public modelsService: ModelsService,
    public formService: FormService,
    public toastService: ToastService,
    private filesService: FilesService,
    injector: Injector) {
    super(activeModal, injector);
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.manufacturerService.getAllManufacturer().subscribe(manu => {
      this.manufacturer = manu
      this.createForm();
    }, error => { })
  }

  createForm() {
    this.formService.validators = {
      manufacturerId: [Validators.required],
      model: [Validators.required],
    }

    this.formService.form = new FormGroup({
      manufacturerId: new FormControl('', this.formService.validators['manufacturerId']),
      model: new FormControl('', this.formService.validators['model']),
      pictureUri: new FormControl(''),
      isErk: new FormControl(0),
      numberOfConnectors: new FormControl(1),
      isOcpp16: new FormControl(0),
      isOcpp20: new FormControl(0),
      isOcpp201: new FormControl(0),
      isUpdatable: new FormControl(0),
      isMobile: new FormControl(0),
      isAc: new FormControl(0),
      isDc: new FormControl(0),
      isPnc: new FormControl(0),
      integrationAt: new FormControl(''),
    });
    this.formCreated = true;
  }


  showWrongFileTypeError() {
    Swal.fire({
      title: $localize`:@@ProfileWrongTypeTitel:Falsches Dateiformat`,
      text: $localize`:@@ProfileWrongTypeText:Die gewählte Datei hat das falsche Format. Erlaubt sind: jpg, jpeg, png.`,
      icon: 'error',
      showConfirmButton: false,
      showDenyButton: true,
      denyButtonText: $localize`:@@ProfileWrongTypeConfirm:Zurück`,
      focusDeny: false,
    })
  }

  showWrongFileSizeError() {
    Swal.fire({
      title: $localize`:@@ProfileWrongSizeTitel:Falsche Dateigröße`,
      text: $localize`:@@ProfileWrongSizeText:Die gewählte Datei ist zu groß. Erlaubt sind Dateien bis zu 2 MB.`,
      icon: 'error',
      confirmButtonText: $localize`:@@ProfileWrongSizeConfirm:Zurück`,
    })
  }

  openSuccessDialog() {
    Swal.fire({
      title: $localize`:@@ChangeDialogSaveSuccessHeader:Einstellungen wurden gespeichert!`,
      icon: 'success',
      confirmButtonText: $localize`:@@DialogOkButton:OK`,
      confirmButtonColor: 'green'
    }).then((result) => {
      this.ngOnInit();
    });
  }

  openCancelSuccessDialog() {
    Swal.fire({
      title: $localize`:@@CancelSubscriptionSuccessHeader:Abo wurde erfolgreich gekündigt!`,
      icon: 'success',
      confirmButtonText: $localize`:@@DialogOkButton:OK`,
      confirmButtonColor: 'green'
    }).then((result) => {
      this.ngOnInit();
    });
  }

  async onFileSelect(event) {
    var picture: File = event.target.files.item(0);

    if (picture) {
      var fileAllowed = false;

      if (picture.type == 'image/jpeg' || picture.type == 'image/jpg' || picture.type == 'image/png') {
        fileAllowed = true;
      }
      else {
        fileAllowed = false;
        this.showWrongFileTypeError();
      }

      if (picture.size > 2000000) {
        fileAllowed = false;
        this.showWrongFileSizeError();
      }

      if (fileAllowed) {
        this.picture = picture;

        var fileExtension = this.picture.name.split('.').pop();
        var fileName = this.picture.name.split('.').shift()

        var blob = this.picture;
        var newFile = new File([blob], fileName + '.' + fileExtension, { type: this.picture.type });
        console.log(fileName);

        var uploadResult = await this.uploadFile(newFile);
        this.pictureUri = uploadResult[0].fileUri;
        console.log(this.pictureUri);
        this.formService.form.controls['pictureUri'].setValue(this.pictureUri);
      }
    }
  }

  async uploadFile(file: File): Promise<UploadResponse[]> {
    var formData = new FormData();
    formData.append("file", file);
    formData.append("path", "chargepoint");

    var result = await this.filesService.uploadAsync(formData, true);

    return result;
  }

  onSubmit(formValue) {

    console.log(formValue);
    var entity = new ModelDto({
      manufacturerId: formValue.manufacturerId,
      integrationDate: formValue.integrationAt,
      pictureUri: formValue.pictureUri,
      name: formValue.model,
      profile: new Profile(
        {
          isAc: formValue.isAc,
          isDc: formValue.isDc,
          isErk: formValue.isErk,
          numberOfConnectors: formValue.numberOfConnectors,
          isUpdatable: formValue.isUpdatable,
          isMobile: formValue.isMobile,
          isOcpp16: formValue.isOcpp16,
          isOcpp20: formValue.isOcpp20,
          isOcpp201: formValue.isOcpp201,
          isPnc: formValue.isPnc,
          name: formValue.model,
        }
      ),
    });

    this.modelsService.createModel(entity).subscribe(data => {
    this.activeModal.close();
      this.toastService.success($localize`:@@CreateDialogSaveSuccessHeader:Profil erfolgreich angelegt.`);
    
    }, error => {
      this.toastService.error($localize`:@@CreateDialogSaveSuccessHeader:Profil konnte nicht gespeichert werden.`);

    });
  }

  selectedTeam = '';

  onSelected(value: string): void {
    this.selectedTeam = value;
    this.formService.form.controls['manufacturerId'].setValue(this.selectedTeam);
    console.log(this.formService.form.controls['isErk'].value);

  }

  setPicture(value:string) {
    this.formService.form.controls['pictureUri'].setValue(this.pictureUri);
  }

  setModel(value: string){
    this.formService.form.controls['model'].setValue(value);
  }

  setDate(value: Date) {
    this.formService.form.controls['integrationAt'].setValue(value);
    console.log(this.formService.form.controls['integrationAt'].value)
  }

  setNumberOfConnectors(value: number) {
    this.formService.form.controls['numberOfConnectors'].setValue(value);
  }

  checked(event) {
    console.log(event);
    if (event.target.checked) {
      this.formService.form.controls[event.target.name].setValue(1);
    } else {
      this.formService.form.controls[event.target.name].setValue(0);

    }
    console.log(this.formService.form.controls[event.target.name].value)
  }

  newEntityEvent(entity: IEntity) {
    this.activeModal.close();
  }
}
